type StatusBadgeProps = {
  status: string;
  className?: string;
};

export default function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  if (status === "live") {
    return (
      <span
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-label font-semibold tracking-wide bg-accent-500 text-background-50 dark:text-foreground-950 ${className}`}
      >
        <span className="bb-live-dot w-1.5 h-1.5 rounded-full bg-background-50 dark:bg-foreground-950" />
        直播中
      </span>
    );
  }
  if (status === "finished") {
    return (
      <span
        className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-label font-semibold tracking-wide bg-secondary-100 text-secondary-800 ${className}`}
      >
        已结束
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-label font-semibold tracking-wide bg-primary-100 text-primary-700 ${className}`}
    >
      未开始
    </span>
  );
}